// extracted by mini-css-extract-plugin
module.exports = {"tablesContainer":"TopBottomTables_tablesContainer__1EFd4","title":"TopBottomTables_title__IIQC9","tableContainer":"TopBottomTables_tableContainer__2YiKn"};